import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const MainLayout: React.FC = () => {
  return (
    <div className="bg-white text-slate-900 min-h-screen flex overflow-hidden font-display">
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default MainLayout;
